import '../resources/css/App.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { resetErrorMessage } from '../actions';
import LoginLayout from './layout/LoginLayout';
import MainLayout from './layout/MainLayout';
import FormLayout from './layout/FormLayout';

class App extends Component {
  static propTypes = {
    // Injected by React Redux
    store: PropTypes.object,
    errorMessage: PropTypes.string,
    resetErrorMessage: PropTypes.func.isRequired,
       
    // Injected by React Router
    children: PropTypes.node
  }

  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Switch>
            <Route path="/Login" exact component={LoginLayout} />
            <Route path="/:navName" exact component={MainLayout} />
            <Route path="/:navName/:formType" exact component={FormLayout} />

            {/*Redirect Need after Route */}
            <Redirect from='/' to='/Login'/> 
          </Switch>
        </BrowserRouter>
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.errorMessage,
  inputValue: ownProps.location.pathname.substring(1)
})

export default withRouter(connect(
  mapStateToProps, 
  {resetErrorMessage}
)(App))
